module.exports = __webpack_public_path__ + "static/media/CurbsideLandingScreen.fb7fb3b3.png";